import { queryKeys } from '../../lib/queryKeys';

/**
 * Re-exported from `lib/queryKeys.ts`. Same story as `activity/queryKeys.ts`:
 * written locally because the shared file was another agent's that round, with
 * its own header asking for exactly this.
 */
export const notificationQueryKeys = {
  all: queryKeys.notifications,
  list: queryKeys.notificationsList,
  count: queryKeys.notificationsCount,
} as const;
